import { Group, Input, Radio } from '@any-ui-react/core';
import classNames from 'classnames';

import { multipleMissionsRatings } from './multipleMissionsRatings.data';

interface Props {
  value: number;
  onClick?: (value: number) => void;
  readonly?: boolean;
  error?: string;
}

const numberRatings = multipleMissionsRatings.map((value, i) => ({
  value: i + 1,
  label: value.max ? `~${value.max}%` : `${value.min}%~`,
}));

export const NumberRating = ({ value = 0, onClick, readonly, error }: Props) => (
  <div className="flex flex-col space-y-1">
    <div
      className={classNames('flex justify-center border rounded px-4 py-3.5 xl:px-11', {
        'bg-gray-0': readonly,
        'border-failure': error,
      })}
    >
      <div className="flex w-full items-center justify-center">
        <Radio.Group
          value={value.toString()}
          onChange={(v: string) => {
            if (readonly) {
              return;
            }

            if (onClick) {
              onClick(Number(v));
            }
          }}
        >
          <Group>
            {numberRatings.map(rating => (
              <div key={rating.value}>
                <Radio
                  className={classNames({
                    'pointer-events-none cursor-default': readonly,
                  })}
                  classNames={{
                    body: 'flex flex-col space-y-2 bg-transparent',
                    inner: 'flex self-center',
                    icon: classNames('!m-auto', { '!text-white': readonly }),
                    radio: classNames({ '!bg-link': readonly && value.toString() === rating.value.toString() }),
                  }}
                  disabled={readonly}
                  label={<div className="text-center items-center text-gray-7">{rating.label}</div>}
                  readOnly={readonly}
                  size="md"
                  value={rating.value.toString()}
                />
              </div>
            ))}
          </Group>
        </Radio.Group>
      </div>
    </div>
    {error && <Input.Error>{error}</Input.Error>}
  </div>
);
